<template>
    <section id="references">
        <div class="container">
            <h2>Reference</h2>

            <f7-row>
                <f7-col width="100" desktop-width="60" tablet-width="100">
                    <h3 data-aos="fade-right" data-aos-duration="1000">NIDV</h3>
                    <p data-aos="zoom-in-up" data-aos-duration="1000">Národní institut pro další vzdělávání (NIDV) je
                        přímo řízená organizace MŠMT s celostátní garancí
                        dalšího vzdělávání a profesního rozvoje pedagogických pracovníků škol i školských zařízení
                        včetně
                        školských zařízení pro zájmové vzdělávání.</p>
                    <p data-aos="zoom-in-down" data-aos-duration="1000">Naši programátoři, architekti i grafici
                        zpracovali pro institut několik webových aplikacích a
                        stránek, které NIDV využívá pro komunikaci s odbornou i laickou veřejností.</p>
                </f7-col>
                <f7-col width="100" desktop-width="40" tablet-width="100">
                    <img data-aos="fade-up" data-aos-duration="1000" src="../assets/img01.jpg" alt="">
                </f7-col>
            </f7-row>

            <f7-row>
                <f7-col width="100" desktop-width="40" tablet-width="100">
                    <img data-aos="fade-up" data-aos-duration="1000" src="../assets/img02.jpg" alt="">
                </f7-col>
                <f7-col width="100" desktop-width="60" tablet-width="100">
                    <h3 class="right" data-aos="fade-down" data-aos-duration="1000">GRiT</h3>
                    <p data-aos="zoom-in-up" data-aos-duration="1000" class="text-right">GRiT, s.r.o. je ryze český
                        softwarehouse od roku 1992, dříve známí pod jménem CCV. Společnost se specializuje na EDI,
                        elektronickou fakturaci, CRM, automatizaci toku dokladů, zboží i peněz a skladové systémy.
                    </p>
                    <p data-aos="zoom-in-down" data-aos-duration="1000" class="text-right">Naši programátoři a
                        architekti implementovali společnosti GRiT systém v Javě s databází Oracle i napojením na
                        externí služby a centrální přihlášení LDAP. Dle zákazníka jsme se mimořádně osvědčili při návrhu
                        a implementaci moderního UI pomocí novodobých technologií jako je webpack.
                    </p>
                </f7-col>

            </f7-row>
            <div class="clearfix"></div>
            <!-- <f7-row>

                <f7-col width="100" desktop-width="60" tablet-width="100">
                    <h3 data-aos="fade-right" data-aos-duration="1000">EMERCONLINE</h3>
                    <p data-aos="zoom-in-up" data-aos-duration="1000">Emerconline a.s. realizuje projekty měření a
                        regulace pomocí technologií předních světových
                        výrobců: Honeywell, Johnson Controls, Domat, Amit, a další. V rámci projektů v oblasti měření a
                        regulace zajišťuje komplexní inženýring, instalaci, záruční a pozáruční servis a poradenství.
                    </p>
                    <p data-aos="zoom-in-down" data-aos-duration="1000">Naši programátoři připravili a implementovali
                        serverovou aplikaci v Nette s databázi MySQL a API
                        Laravel. Dále Frontend ECMAScript společně s webpack i mobilními aplikacemi pro iOS
                        (iPhone/iPad).
                    </p>
                </f7-col>
                <f7-col width="100" desktop-width="40" tablet-width="100">
                    <img data-aos="fade-up" data-aos-duration="1000" src="../assets/img03.jpg" alt="">
                </f7-col>

            </f7-row> -->


        </div>
    </section>
</template>

<script>
    export default {

    }
</script>

<style>
    #references {
        /* background: #2980b9; */
        padding: 11% 0;
        min-height: 50vh;
        color: #fff;
    }

    .text-right {
        text-align: justify;
        position: relative;
        float: right;
    }

    h3 {
        text-align: left;
        font-size: 1.5rem;
    }

    .right {
        text-align: right;
    }

    .row {
        margin-bottom: 30px;
    }

    .clearfix {
        overflow: auto;
    }
</style>